<template>
  <div class="avatar-wrapper">
    <img class="avatar" v-if="showImage" :src="data" @error="imgError"/>
    <inline-svg name="rackets" v-else></inline-svg>
  </div>
</template>

<script>

  export default {
    props: ['data'],
    data () {
      return {
        showImage: true
      }
    },
    methods: {
      imgError () {
        this.showImage = false
      }
    }
  }

</script>

<style lang="scss" scoped>

  .avatar-wrapper {
    position: relative;
    display: none;
    vertical-align: middle;
    @include size(4rem);
    border-radius: 50%;
    margin-right: 1rem;
    overflow: hidden;
    text-align: center;
    background: linear-gradient(to bottom left, #0092A6, #23395B);

    @include respond-to(medium) {
      display: inline-block;
    }

    .rackets {
      position: relative;
      top: -3px;
      width: 2.8rem;
    }

    img {
      max-width: 100%;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/UserAvatar.vue